import React from 'react';
import { PageGenericError } from '../pages/PageGenericError/PageGenericError';

export class ErrorBoundary extends React.Component {
  state: { hasError: boolean };
  
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.log('error: ', error);
    console.log('errorInfo: ', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <PageGenericError />;
    }

    return this.props.children; 
  }
}
